<template>
  <div class="container">
    <PublicHeader :totalName="$t('position').title" />
    <!-- 订单详情 -->
    <div class="orderInfoss">
      <!-- 名称 -->
      <div class="item">{{ $t('position').product }}<span>{{ orderInfo.name }}</span></div>
      <!-- 方向 -->
      <div class="item">{{ $t('position').direction }}<span :class="orderInfo.buyDirection == '0' ? 'green' : 'red'">{{ orderInfo.buyDirection == '0' ?
                  $t('trade').buyUp : $t('trade').buyDown}}</span></div>
      <!-- 委托价 -->
      <div class="item">{{ $t('position').Entrustedprice }}<span>{{ orderInfo.price }}</span></div>
      <!-- 委托数量 -->
      <!-- <div class="item">{{ $t('position').Entrustednum }}<span>{{ orderInfo.quantity }}</span></div> -->
      <!-- 订单金额 -->
      <div class="item">{{ $t('position').orderAmount }}<span>{{ orderInfo.amount }}</span></div>
      <!-- 委托时间 -->
      <div class="item">{{ $t('position').Entrustedtime }}<span>{{ orderInfo.createTime | getLocalTime }}</span></div>
      <!-- 秒数 -->
      <div class="item">{{ $t('trade').secondNums }}<span>{{ orderInfo.second }}s</span></div>
      <!-- 收益率 -->
      <div class="item">{{ $t('trade').incomeRates }}<span>{{ orderInfo.yield }}%</span></div>
      <!-- 手续费 -->
      <div class="item">{{ $t('position').changeRate }}<span>{{ orderInfo.changeRate||'-' }}</span></div>
      <!-- 盈亏 -->
      <div class="item">{{ $t('position').profitloss }}<span :class="orderInfo.profitAmount > 0 ? 'green' : 'red'">{{ orderInfo.profitAmount||'-'  }}</span></div>
      <!-- 结算时间 -->
      <div class="item" v-if="orderInfo.status == '3'">{{ $t('position').Settlementtime }}<span>{{ orderInfo.salesTime | getLocalTime }}</span></div>
      <!-- 订单号 -->
      <div class="item">{{ $t('position').orderno }}<span>{{ orderInfo.orderNo }}<svg-icon class-name="svgs" icon-class="copy" @click="onCopy(orderInfo.orderNo)" /></span></div>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import orderApi from '@/api/order'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      orderInfo: {},
      orderSecondId: null,
    }
  },
  mounted() {
    if (this.$route.query.i) {
      this.orderSecondId = this.$route.query.i
      this.getSecondOrderInfo()
    }
  },
  methods: {
    // 详情
    async getSecondOrderInfo() {
      const res = await orderApi.getSecondOrderInfo({ orderSecondId: this.orderSecondId })
      this.orderInfo = res.data
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .orderInfoss {
    padding: 50px 15px 20px 15px;

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
      }
    }

    .btn {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      border-radius: 20px;
      font-size: 15px;
      color: var(--background_color);
      background: var(--text_color);
    }

    .btns {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      .b1 {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--text_color);
        background: var(--info_color);
      }

      .b2 {
        margin-left: 15px;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--background_color);
        background: var(--text_color);
      }
    }
  }
}
</style>
